module.exports = __webpack_public_path__ + "static/media/yelpcamp.e0203e51.gif";